import { apiFetch } from "./config.js";
/**
 * Fetch aggregate pipeline stats for the dashboard app (counts and value
 * totals by ClaimCandidate status and by recommended forum, plus upcoming
 * hearing and limitation-flag counts). Wrap in `useQuery` with a queryKey
 * of `["dashboard", "pipeline-summary"]`.
 */
export async function getDashboardPipelineSummary(signal) {
    return apiFetch("/dashboard/pipeline-summary", {
        method: "GET",
        signal,
    });
}
/**
 * Fetch the dashboard app's exposure view: adverse findings, findings whose
 * authority status is still live, and outstanding company disallowances,
 * plus a de-duplicated headline total and a highest-exposure shortlist.
 * Wrap in `useQuery` with a queryKey of `["dashboard", "exposure"]`.
 */
export async function getDashboardExposure(signal) {
    return apiFetch("/dashboard/exposure", { method: "GET", signal });
}
/**
 * Fetch the dashboard app's periodic digest history, newest period first.
 * `periods` defaults to 3 (the current partial period plus two prior full
 * months) on the server if omitted. Wrap in `useQuery` with a queryKey of
 * `["dashboard", "digest", periods]`.
 */
export async function getDashboardDigest(periods, signal) {
    const search = periods !== undefined ? `?periods=${periods}` : "";
    return apiFetch(`/dashboard/digest${search}`, { method: "GET", signal });
}
